import { useEffect, useState } from 'react';

const getFunLinkPageDataPromise = () => {
  if (!window.__FUN_LINK_PAGE_DATA_PROMISE__) {
    return Promise.reject('找不到 window.__FUN_LINK_PAGE_DATA_PROMISE__ 配置');
  }
  return window.__FUN_LINK_PAGE_DATA_PROMISE__;
};

/**
 * 获取 funLink page data 数据
 */
export const useFunLinkPageDataPromise = () => {
  const [funLinkPageDataPromise, setFunLinkPageDataPromiseState] = useState(() => getFunLinkPageDataPromise());

  useEffect(() => {
    const funLinkDevController = window.FUN_LINK_DEV_CONTROLLER;
    if (funLinkDevController) {
      const setFunLinkPageDataPromiseStateCb = () => {
        setFunLinkPageDataPromiseState(getFunLinkPageDataPromise());
      };
      funLinkDevController.on(funLinkDevController.FUN_LINK_EVENT.pageDataChange, setFunLinkPageDataPromiseStateCb);

      return () => {
        funLinkDevController.off(funLinkDevController.FUN_LINK_EVENT.pageDataChange, setFunLinkPageDataPromiseStateCb);
      };
    }
  }, []);

  return funLinkPageDataPromise;
};

const useFunLinkPageData = () => {
  const funLinkPageDataPromise = useFunLinkPageDataPromise();

  const [funLinkPageData, setFunLinkPageData] = useState(undefined);

  useEffect(
    () => {
      if (!funLinkPageDataPromise) {
        return;
      }
      funLinkPageDataPromise
        ?.then(dataSource => {
          setFunLinkPageData(dataSource.data);
        })
        .catch(err => {
          console.error(err);
        });
    },
    [funLinkPageDataPromise]
  );

  return funLinkPageData;
};

export default useFunLinkPageData;
